import { ECompanyType } from '../../../../repositories/coworking/v1/apply-for-publication';

import { EPlacementApplicationFormFields } from '../enums';
import { TPlacementApplicationFormActionsType, TPlacementApplicationFormState } from '../types';

import { EValidateActionTypes } from './enums';
import { validationRules, validationRulesEntries } from './utils';

export const getPlacementApplicationFormInitialState = (
  fields?: Partial<TPlacementApplicationFormState>,
): TPlacementApplicationFormState => ({
  [EPlacementApplicationFormFields.CompanyName]: { errorMessage: null, value: '' },
  [EPlacementApplicationFormFields.CompanyType]: { errorMessage: null, value: ECompanyType.Operator },
  [EPlacementApplicationFormFields.Email]: { errorMessage: null, value: '' },
  [EPlacementApplicationFormFields.Phone]: { errorMessage: null, value: '' },
  ...fields,
});

export function placementApplicationFormReducer(
  state: TPlacementApplicationFormState,
  action: TPlacementApplicationFormActionsType,
): TPlacementApplicationFormState {
  switch (action.type) {
    case EPlacementApplicationFormFields.CompanyName:
    case EPlacementApplicationFormFields.Email:
    case EPlacementApplicationFormFields.Phone:
      return {
        ...state,
        [action.type]: {
          value: action.payload,
          errorMessage: null,
        },
      };

    case EPlacementApplicationFormFields.CompanyType:
      return {
        ...state,
        [action.type]: {
          value: action.payload,
          errorMessage: null,
        },
      };

    case EValidateActionTypes.ValidateByField:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          errorMessage: validationRules[action.payload](state[action.payload].value, state),
        },
      };

    case EValidateActionTypes.ValidateAll:
      return validationRulesEntries.reduce<TPlacementApplicationFormState>((accumulator, currentValue) => {
        const [ruleKey, ruleFunc] = currentValue;

        return {
          ...accumulator,
          [ruleKey]: {
            ...accumulator[ruleKey],
            errorMessage: ruleFunc(accumulator[ruleKey].value, state),
          },
        };
      }, state);

    // istanbul ignore next
    default:
      return state;
  }
}
